(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;
  var closeTimer = null;
  var busy = false;

  function getDrawer() { return document.getElementById('CartDrawer'); }
  function getPanel() { var drawer = getDrawer(); return drawer && drawer.querySelector('.cart-drawer__panel'); }

  function updateCount(count) {
    if (count === undefined || count === null) return;
    document.querySelectorAll('#cart_items, #cart_item_mobile').forEach(function (el) {
      el.textContent = count;
    });
  }

  function showError(message) {
    var drawer = getDrawer();
    var error = drawer && drawer.querySelector('[data-cart-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function renderContents(html, announce) {
    var drawer = getDrawer();
    if (!drawer || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawerContents');
    var current = document.getElementById('CartDrawerContents');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    updateCount(fresh.dataset.cartCount);
    if (announce) {
      var status = fresh.querySelector('[data-cart-status]');
      if (status) status.textContent = drawer.dataset.updatedLabel || '';
    }
  }

  function refresh(openAfter) {
    var drawer = getDrawer();
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.dataset.sectionId;
    return fetch(root + '?sections=' + encodeURIComponent(sectionId))
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        renderContents(sections[sectionId]);
        showError('');
        if (openAfter) open();
      })
      .catch(function () {
        if (openAfter) window.location.href = root + 'cart';
      });
  }

  function open() {
    var drawer = getDrawer();
    var panel = getPanel();
    if (!drawer || !panel) return;
    clearTimeout(closeTimer);
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('cart-drawer-open');
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    panel.focus();
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function focusLine(line) {
    var input = document.getElementById('CartDrawerQuantity-' + line);
    (input || getPanel()).focus();
  }

  function changeLine(line, quantity) {
    var drawer = getDrawer();
    if (!drawer || busy || !line || isNaN(quantity) || quantity < 0) return;
    busy = true;
    drawer.classList.add('is-busy');
    var sectionId = drawer.dataset.sectionId;

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId], sections_url: window.location.pathname })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw result.data;
        showError('');
        renderContents(result.data.sections && result.data.sections[sectionId], true);
        updateCount(result.data.item_count);
        focusLine(line);
      })
      .catch(function (error) {
        var message = (error && (error.description || error.message)) || '';
        return refresh().then(function () {
          showError(message);
          focusLine(line);
        });
      })
      .then(function () {
        busy = false;
        drawer.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var cartLink = event.target.closest('.header_cart .cart_link');
    if (cartLink && getDrawer() && !document.body.classList.contains('template-cart')) {
      event.preventDefault();
      event.stopPropagation();
      open();
      return;
    }

    var drawer = getDrawer();
    if (!drawer || !drawer.contains(event.target)) return;

    if (event.target.closest('[data-cart-drawer-close]')) {
      close();
      return;
    }

    var step = event.target.closest('[data-cart-quantity]');
    if (step) changeLine(Number(step.dataset.cartLine), Number(step.dataset.cartQuantity));
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('#CartDrawer .cart-drawer__input');
    if (!input) return;
    var quantity = parseInt(input.value, 10);
    if (!isNaN(quantity) && quantity >= 0) changeLine(Number(input.dataset.cartLine), quantity);
  });

  document.addEventListener('keydown', function (event) {
    var drawer = getDrawer();
    if (!drawer || drawer.hidden) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(getPanel().querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === getPanel())) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    var drawer = getDrawer();
    if (drawer && event.detail.sectionId === drawer.dataset.sectionId) open();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var drawer = getDrawer();
    if (drawer && event.detail.sectionId === drawer.dataset.sectionId) close();
  });

  window.CartDrawer = { open: open, close: close, refresh: refresh };
})();
